<template>
  <Teleport to="body">
    <div v-if="state.visible" :class="$style['confirm']">
      <div :class="$style['confirm-bg']" @click="answer(false)" />
      <div :class="$style['confirm-wrapper']">
        <p :class="$style['confirm-message']">{{ state.message }}</p>
        <div :class="$style['confirm-actions']">
          <Button @click="answer(false)">Annuleren</Button>
          <Button color="cta" @click="answer(true)">Bevestigen</Button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script setup lang="ts">
const { state, answer } = useConfirm()
</script>
<style module>
.confirm {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 30;
}

.confirm-bg {
  background: var(--curtain);
  backdrop-filter: blur(2px);
  position: fixed;
  inset: 0;
}

.confirm-wrapper {
  background-color: var(--background-raised);
  border: 1px solid var(--border-subtle);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow-elevation-4);
  padding: var(--spacing-xl);
  max-width: 30rem;
  width: calc(100% - var(--spacing-xxl));
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
}

.confirm-message {
  margin: 0;
  font-size: var(--font-size-medium);
}

.confirm-actions {
  display: flex;
  gap: var(--spacing);
  justify-content: flex-end;
}
</style>
